export default __webpack_public_path__ + "static/media/agregaciones1.cd01cb4d.svg";